// npm install bootstrap@5.2.3
import "bootstrap/dist/css/bootstrap.min.css";
//import "bootstrap-icons/font/bootstrap-icons.css";
import "./../node_modules/bootstrap-icons/font/bootstrap-icons.css";

import "bootstrap/dist/js/bootstrap.js";

import React from 'react';
import ReactDOM from 'react-dom/client';

import { AuthContextProvider } from "./store/auth-context";

import './index.css';
import App from './App';

// <React.StrictMode>   </React.StrictMode>   Verwijderd t.b.v. drag & drop
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthContextProvider>
    <App />
  </AuthContextProvider>
);
